import Button from "@mui/material/Button";
import { ShareIcon } from "../../../atoms/icons/share";
import { ChatReviewIcon } from "../../../atoms/icons/chat-review";
import { CloseIcon } from "../../../atoms/icons/close";
import React from "react";
import { LoanDetails } from "./LoanDetails";

export const ViewDetailsDesktopModalContent = React.forwardRef(function (
  {
    setShowDetailsModal,
    onShareClick,
    onReviewClick,
    onEditClick,
    taxes,
    insurance,
    earnestMoney,
    credits,
    downPayment,
    insurancePaymentMonth,
    plannedClosingDate,
    hasWaivedEscrow,
    details,
    content,
  },
  ref
) {
  return (
    <div ref={ref} className="custom-modal custom-modal-desktop">
      <div className="modal-main-content">
        <div className="top-row">Loan Summary</div>
        <div className="middle-row">
          <LoanDetails
            details={details}
            downPayment={downPayment}
            insurancePaymentMonth={insurancePaymentMonth}
            plannedClosingDate={plannedClosingDate}
            hasWaivedEscrow={hasWaivedEscrow}
            insurance={insurance}
            earnestMoney={earnestMoney}
            credits={credits}
            taxes={taxes}
            onEditClick={onEditClick}
            content={content}
          />
        </div>
        <div className="bottom-row">
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: "#00e09d",
              color: "white",
              paddingLeft: "50px",
              paddingRight: "50px",
              textTransform: "none",
              flex: 1,
              fontFamily: "proxima-nova, sans-serif",
              fontWeight: "bold",
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#009b62",
                color: "white",
              },
            }}
            href="/apply"
          >
            Apply Now
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.4)",
              color: "white",
              paddingLeft: "40px",
              paddingRight: "40px",
              display: "flex",
              alignItems: "center",
              flex: 1,
              textTransform: "none",
              fontFamily: "proxima-nova, sans-serif",
              fontWeight: "bold",
              fontSize: "16px",
              lineHeight: "1.3",
              minHeight: 40,
              "&:hover": {
                backgroundColor: "#243046",
              },
            }}
            startIcon={<ShareIcon fill="white" width="20" height="20" />}
            onClick={onShareClick}
          >
            Share this loan option
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              fontFamily: "proxima-nova, sans-serif",
              fontWeight: "bold",
              fontSize: "16px",
              backgroundColor: "rgba(255, 255, 255, 0.4)",
              color: "white",
              paddingLeft: "40px",
              paddingRight: "40px",
              display: "flex",
              alignItems: "center",
              flex: 1,
              textTransform: "none",
              lineHeight: "1.3",
              minHeight: 40,
              "&:hover": {
                backgroundColor: "#243046",
              },
            }}
            startIcon={<ChatReviewIcon fill="white" width="24" height="24" />}
            onClick={onReviewClick}
          >
            Review with a loan officer
          </Button>
        </div>
      </div>
      <div className="close-button" onClick={() => setShowDetailsModal(false)}>
        <CloseIcon />
      </div>
    </div>
  );
});
